import { useMemo } from 'react';
import { Platform, StyleSheet } from 'react-native';
import { useColors } from '../../hooks/useColors';
import { useScale } from '../../hooks/useScale';
import theme from '../../common/theme';

const isWeb = Platform.OS === 'web';

const ActionPanelStyles = () => {
  const { colors } = useColors();
  const { scale } = useScale();

  return useMemo(
    () =>
      StyleSheet.create({
        action: {
          flexDirection: 'row',
          height: scale(60),
        },
        btn: {
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
        },
        btnText: {
          color: colors.white,
          fontFamily: theme.fonts.bold,
          fontSize: scale(14),
        },
        section: {
          marginVertical: scale(12),
          width: '100%',
          gap: scale(8),
        },
        sectionTitle: {
          height: scale(28),
          color: colors.textLight,
          fontFamily: theme.fonts.semibold,
          fontSize: scale(14),
          paddingLeft: scale(10),
        },
        moveBtnContainer: {
          flexDirection: 'row',
          columnGap: scale(8),
        },
        moveBtn: {
          height: scale(64),
          width: scale(64),
          backgroundColor: colors.background,
          borderRadius: theme.radius.s,
          alignItems: 'center',
          justifyContent: 'center',
        },
        actionBtn: {
          height: scale(44),
          width: '100%',
          backgroundColor: colors.background,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingHorizontal: scale(10),
          borderRadius: theme.radius.s,
        },
        actionText: {
          color: colors.text,
          fontFamily: theme.fonts.semibold,
          fontSize: scale(14),
        },
        tagApplyBtn: {
          backgroundColor: colors.blue,
          alignItems: 'center',
          justifyContent: 'center',
        },
        tagApplyBtnText: {
          fontFamily: theme.fonts.regular,
          color: colors.white,
        },
        tagOptionsContainer: {
          flexDirection: 'row',
          gap: isWeb ? scale(8) : scale(7),
          flexWrap: 'wrap',
        },
        tagOptionLabel: {
          fontSize: scale(20),
        },
        tagOption: {
          width: scale(64),
          height: scale(64),
          backgroundColor: colors.background,
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: theme.radius.s,
        },
        tagOptionSelected: {
          borderWidth: scale(2),
          borderColor: colors.accent,
        },
      }),
    [colors, scale],
  );
};

export default ActionPanelStyles;
